import { GAME_CATEGORY } from "./game.constants";

export const REDUX_RULES_STORE_FIELD = {
	[GAME_CATEGORY.SCHEDULED]: "scheduledRules",
	[GAME_CATEGORY.INSTANT]: "instantRules"
};
